export function parseApiUrl({ searchApi, autocompleteApi }) {
    var search = new URL(searchApi);
    var autocomplete = new URL(autocompleteApi);

    return {
        apiUrl: search.origin,
        searchUrl: search.pathname,
        autocompleteUrl: autocomplete.href
    }
}

export function getDashboardUrl(baseApi) {
    var obj = new URL(baseApi);

    return obj.origin;
}

export function customPolyfills() {
    if (!Promise.hasOwnProperty('allSettled')) {
        const formatSettledResult = (success, value) => success ? { status: 'fulfilled', value } : {
            status: 'rejected',
            reason: value
        };
        Promise.allSettled = function (iterators) {
            const promises = Array.from(iterators);
            const num = promises.length;
            const settledList = new Array(num);
            let settledNum = 0;
            return new Promise(resolve => {
                promises.forEach((promise, index) => {
                    Promise.resolve(promise).then(value => {
                        settledList[index] = formatSettledResult(true, value);
                        if (++settledNum === num) {
                            resolve(settledList);
                        }
                    }).catch(error => {
                        settledList[index] = formatSettledResult(false, error);
                        if (++settledNum === num) {
                            resolve(settledList);
                        }
                    });
                });
            });
        };
    }

    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (str, newStr) {

            if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
                return this.replace(str, newStr);
            }

            return this.replace(new RegExp(str, 'g'), newStr);
        };
    }

    if (typeof fetch == 'undefined') {
        var polyfillElement = document.createElement('script');
        polyfillElement.setAttribute('src', 'https://cdn.polyfill.io/v3/polyfill.min.js?features=fetch');
        document.head.appendChild(polyfillElement);
    }
}